import MessengerView from './MessengerView';

export default MessengerView;
